// src/services/userServices.js
import api from './api';

export const fetchUsers = async (search, page) => {
  const response = await api.get('/users', {
    params: { search, page },
  });
  return response.data;
};

export const fetchUserById = async (userId) => {
  const response = await api.get(`/users/${userId}`);
  return response.data;
};

export const updateUser = async (userData) => {
  const response = await api.put(`/users/${userData.id}`, userData);
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
}

export const deleteUser = async (userId) => {
  const response = await api.delete(`/users/${userId}`);
  return response.data;
};

export const changeUserPassword = async (userId, newPassword, currentPassword = null) => {
  const body = { newPassword };
  if (currentPassword) {
    body.currentPassword = currentPassword;
  }
  const response = await api.put(`/users/${userId}/password`, body);
  return response.data;
};

export const fetchPermissions = async () => {
  const response = await api.get('/users/permissions');
  return response.data;
};
